import type { ComponentChildren } from 'preact';
import { cn } from '@/lib/cn';

export interface KbdProps {
  children: ComponentChildren;
  size?: 'sm' | 'md';
  className?: string;
}

export function Kbd({ children, size = 'sm', className }: KbdProps) {
  return (
    <kbd
      className={cn(
        'inline-flex items-center justify-center rounded-xs border border-border-strong bg-surface-2 font-mono font-medium text-fg-muted shadow-xs',
        size === 'sm' ? 'h-4 min-w-[1rem] px-1 text-3xs' : 'h-5 min-w-[1.25rem] px-1.5 text-2xs',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
